import { render, staticRenderFns } from "./program_unggulan.vue?vue&type=template&id=902da0da&"
import script from "./program_unggulan.vue?vue&type=script&lang=js&"
export * from "./program_unggulan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports